import React, { useEffect } from 'react';

export const Main = ({ children }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return <main className="main-container">{children}</main>;
};
